import * as http from '@/utils/api'
import {
  CLEAR_USER_SEARCH_RESULT,
  GET_USER_SEARCH,
  PATCH_USER_REGISTER_CONFIRM,
  POST_USER_PROFILE,
  POST_USER_REGISTER
} from './types'
import {
  ENDPOINT_USER_PROFILE,
  ENDPOINT_USER_REGISTER,
  ENDPOINT_USER_REGISTER_CONFIRM,
  ENDPOINT_USER_SEARCH
} from '@/constants/endpoint'
import { isEmptyObject } from '@/utils/common'
import {
  LOADING_TYPE_PAGE,
  LOADING_TYPE_USER_SEARCH
} from '@/constants/constant'

export default {
  state: {
    user: null
  },
  mutations: {
    [GET_USER_SEARCH](state, responseData) {
      if (!isEmptyObject(responseData)) {
        state.user = responseData
      }
    },
    [CLEAR_USER_SEARCH_RESULT](state) {
      state.user = null
    }
  },
  getters: {
    user: state => state.user
  },
  actions: {
    [POST_USER_REGISTER]: async ({ dispatch }, params) => {
      await http
        .post(ENDPOINT_USER_REGISTER, params, LOADING_TYPE_PAGE)
        .catch(error => {
          http.handleError(dispatch, error)
          throw new Error()
        })
    },
    [POST_USER_PROFILE]: async ({ dispatch }, params) => {
      await http
        .post(ENDPOINT_USER_PROFILE, params, LOADING_TYPE_PAGE)
        .catch(error => {
          http.handleError(dispatch, error)
          throw new Error()
        })
    },
    [PATCH_USER_REGISTER_CONFIRM]: async ({ dispatch }, params) => {
      await http.patch(ENDPOINT_USER_REGISTER_CONFIRM, params).catch(error => {
        http.handleError(dispatch, error)
        throw new Error()
      })
    },
    [GET_USER_SEARCH]: async ({ commit, dispatch }, min_care_id) => {
      commit(CLEAR_USER_SEARCH_RESULT)
      await http
        .get(
          ENDPOINT_USER_SEARCH + '/' + min_care_id,
          {},
          LOADING_TYPE_USER_SEARCH
        )
        .then(response => {
          commit(GET_USER_SEARCH, response.data)
        })
        .catch(error => {
          http.handleError(dispatch, error)
        })
    },
    [CLEAR_USER_SEARCH_RESULT]({ commit }) {
      commit(CLEAR_USER_SEARCH_RESULT)
    }
  }
}
